import { lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import routes from './Constant';
import PrivateRoute from './PrivateRoute';
import { type AppRoute } from './AppRoutes';
import { PermissionCategory, PermissionSubcategory } from '../utils/permissionConstants';
import TripDetails from '../pages/Dashboard/Trips/TripDetail';
import Routes from '../pages/Dashboard/Directories/Routes';
import Addresses from '../pages/Dashboard/Directories/Address/Addresses';
import RouteDetails from '../pages/Dashboard/Directories/RouteDetails';
import AddVehicleForm from '../pages/Dashboard/Directories/NewVehicle';
import Alerts from '../pages/Dashboard/Alarm/Vehicle-Alerts/Alerts';
import VehicleAllAlerts from '../pages/Dashboard/Alarm/Vehicle-Alerts/components/viewAllAlerts';
import VehicleAlertDetail from '../pages/Dashboard/Alarm/Vehicle-Alerts/components/AlertDetails';
import Devices from '../pages/Dashboard/Directories/Devices/Devices';
import DeviceDetails from '../pages/Dashboard/Directories/Devices/DeviceDetails';
import AddDevice from '../pages/Dashboard/Directories/Devices/AddDevice';
import VideosPlayback from '../pages/Dashboard/Directories/vehicle/VideosPlayback';
import VehicleDetails from '../pages/Dashboard/Directories/vehicle/VehicleDetails';
import Vehicles from '../pages/Dashboard/Directories/vehicle/Vehicles';
import EditGroup from '../pages/Dashboard/Directories/Groups/EditGroup';
import DriverAlerts from '../pages/Dashboard/Alarm/Driver-Alerts/DriverAlerts';
import DriverAlertDashboard from '../pages/Dashboard/Alarm/Driver-Alerts/Dashboard';
import VehicleDashboard from '../pages/Dashboard/Directories/components/VehicleDashboard';
import SosModal from '../common/components/SosModal';
import VideoSectionViewAll from '../pages/Dashboard/Home/components/KnowledgeCentre/VideoSectionViewAll';
import CreateCustomReports from '../pages/Dashboard/Reports/components/CreateCustomReports';
import ArticleSectionViewAll from '../pages/Dashboard/Home/components/KnowledgeCentre/ArticleSectionViewAll';
import CustomReportCardDetal from '../pages/Dashboard/Reports/components/CustomReportCardDetal';
import EditCustomReports from '../pages/Dashboard/Reports/components/EditCustomReports';
import TripAllAlerts from '../pages/Dashboard/Trips/componenets/TripAllAlerts';
import FaqsViewAll from '../pages/Dashboard/Home/components/KnowledgeCentre/FaqsViewAll';
import VehiclesSmartMobility from '../pages/Dashboard/Home/components/KnowledgeCentre/ArticlesPages/VehiclesSmartMobility';
import ComprehesiveSafetySolutions from '../pages/Dashboard/Home/components/KnowledgeCentre/ArticlesPages/ComprehesiveSafetySolutions';
import DMSAdvantage from '../pages/Dashboard/Home/components/KnowledgeCentre/ArticlesPages/DMSAdvantage';
import DriverSafetySystem from '../pages/Dashboard/Home/components/KnowledgeCentre/ArticlesPages/DriverSafetySystem';
import DriverCoaching from '../pages/Dashboard/Alarm/Driver-Coaching';
import Customization from '../pages/Dashboard/Admin/Customization';
import DeviceLogs from '../pages/Dashboard/Admin/components/DeviceLogs';
import UserAccount from '../pages/Dashboard/Admin/UserAccount';
import DriverCoachingDashboard from '../pages/Dashboard/Alarm/Driver-Coaching/Dashboard';
import TransformingTheFuture from '../pages/Dashboard/Home/components/KnowledgeCentre/ArticlesPages/TransformingTheFuture';
import HowToAvoidSleep from '../pages/Dashboard/Home/components/KnowledgeCentre/ArticlesPages/HowToAvoidSleep';
import DashCam from '../pages/Dashboard/Home/components/KnowledgeCentre/ArticlesPages/DashCam';
import AftermarketTelematics from '../pages/Dashboard/Home/components/KnowledgeCentre/ArticlesPages/AftermarketTelematics';
import AdasIsImportant from '../pages/Dashboard/Home/components/KnowledgeCentre/ArticlesPages/AdasIsImportant';
import AutonomousVehicles from '../pages/Dashboard/Home/components/KnowledgeCentre/ArticlesPages/AutonomousVehicles';
import BeyondADAS from '../pages/Dashboard/Home/components/KnowledgeCentre/ArticlesPages/BeyondADAS';
import DriverMonitoring from '../pages/Dashboard/Home/components/KnowledgeCentre/ArticlesPages/DriverMonitoring';
import DeviceUpdates from '../pages/Dashboard/Admin/components/DeviceUpdates';
import AdminManageAlerts from '../pages/Dashboard/Admin/components/AdminManageAlerts';
import CoachingDetails from '../pages/Dashboard/Alarm/Driver-Coaching/Dashboard/components/CoachingDetails';
import NovusSafePro from '../pages/Dashboard/Home/components/KnowledgeCentre/ArticlesPages/NovusSafePro';
import NovusLite from '../pages/Dashboard/Home/components/KnowledgeCentre/ArticlesPages/NovusLite';
import UserSettings from '../pages/Dashboard/Admin/UserSettings';
import LiveStreamingConfig from '../pages/Dashboard/Admin/LiveStreamingConfig';
import UserAccessControls from '../pages/Dashboard/Admin/UserAccessControls';
import DocumentsTable from '../pages/Dashboard/Directories/Documents/DocumentsTable';
import UserCreateBanner from '../pages/Dashboard/Admin/UserCreateBanner';
import LiveVideoExtModal from '../common/components/LiveVideoExtModal';
import ApiDocumentation from '../pages/Documentation/ApiDocumentation';
import NewSubscription from '../pages/Dashboard/Admin/components/client-subscription-components/NewSubscription';
import RenewSubscription from '../pages/Dashboard/Admin/components/client-subscription-components/RenewSubscription';
import InternalSubscriptionTable from '../pages/Dashboard/Admin/InternalSubscriptionTable';
import NewInterNalSubscription from '../pages/Dashboard/Admin/components/internal-subscription-components/NewInterNalSubscription';

// Lazy-loaded components
const ServiceMasterPage = lazy(() => import('../pages/Dashboard/ServicePage/ServiceMasterPage'));
const LoginPage = lazy(() => import('../pages/Auth/Login'));
const Broadcast = lazy(() => import('../pages/Dashboard/Alarm/Broadcast/Broadcast'));
const NewBroadCast = lazy(() => import('../pages/Dashboard/Alarm/Broadcast/NewBroadcast'));
const DuplicateBroadcast = lazy(() => import('../pages/Dashboard/Alarm/Broadcast/DuplicateBroadcast'));
const BrodcastDetail = lazy(() => import('../pages/Dashboard/Alarm/Broadcast/BrodcastDetail'));
const EditBroadcast = lazy(() => import('../pages/Dashboard/Alarm/Broadcast/EditBroadcast'));
const DashboardPage = lazy(() => import('../pages/Dashboard/Home/home'));
const TripsPage = lazy(() => import('../pages/Dashboard/Trips/Trips'));
const TroubleShootPage = lazy(() => import('../pages/Dashboard/Support/TroubleShoot/TroubleShoot'));
const HelpDeskPage = lazy(() => import('../pages/Dashboard/Support/HelpDesk/Support'));
const HelpDeskDetailPage = lazy(() => import('../pages/Dashboard/Support/HelpDesk/SupportDetail'));
const NewTripsPage = lazy(() => import('../pages/Dashboard/Trips/NewTrip'));
const ReportsPage = lazy(() => import('../pages/Dashboard//Reports/AllReports'));
const ScheduledReportsPage = lazy(() => import('../pages/Dashboard//Reports/ScheduledReports'));
const ManagerReportPage = lazy(() => import('../pages/Dashboard//Reports//components/ManagerReport'));
const AlarmReportPage = lazy(() => import('../pages/Dashboard//Reports//components/AlarmReport'));
const DriverPerformanceReportPage = lazy(
  () => import('../pages/Dashboard//Reports//components/DriverPerformanceReport'),
);
const DeviceIgnitionReportPage = lazy(
  () => import('../pages/Dashboard//Reports//components/DeviceIgnitionReport'),
);
const DeviceHealthReportPage = lazy(
  () => import('../pages/Dashboard//Reports//components/DeviceHealthReport'),
);
const DailyKmReportPage = lazy(() => import('../pages/Dashboard//Reports//components/DailyKmReport'));
const DailyRunReportPage = lazy(() => import('../pages/Dashboard//Reports//components/DailyRunReport'));
const DailyEventReportPage = lazy(() => import('../pages/Dashboard//Reports//components/DailyEventReport'));
const NightDriveReportPage = lazy(() => import('../pages/Dashboard//Reports//components/NightDriveReport'));
const ContinousDrivingReportPage = lazy(
  () => import('../pages/Dashboard//Reports//components/ContinousDrivingReport'),
);
const StoppageReportPage = lazy(() => import('../pages/Dashboard//Reports//components/StoppageReport'));
const GeoFencingReportPage = lazy(() => import('../pages/Dashboard//Reports//components/GeoFencingReport'));
const PassengersReportsPage = lazy(() => import('../pages/Dashboard//Reports//components/PassengersReports'));
const ELockUnLockReportPage = lazy(() => import('../pages/Dashboard//Reports//components/ELockUnLockReport'));
const TripVehicleSummaryPage = lazy(
  () => import('../pages/Dashboard//Reports//components/TripVehicleSummary'),
);
const NewRoutePage = lazy(() => import('../pages/Dashboard/Directories/NewRoute'));
const NewAddressPage = lazy(() => import('../pages/Dashboard/Directories/Address/NewAddress'));
const TripReconstruction = lazy(() => import('../pages/Dashboard/Trips/TripReconstruction'));
const TripMap = lazy(() => import('../pages/Dashboard/Trips/TripMap'));
const NewDriver = lazy(() => import('../pages/Dashboard/Directories/Drivers/NewDriver'));
const TRDetail = lazy(() => import('../pages/Dashboard/Trips/TRDetail'));
const TRDetailPlay = lazy(() => import('../pages/Dashboard/Trips/TRplay'));

const DriverPage = lazy(() => import('../pages/Dashboard/Directories/Drivers/Driver'));
const NotificationViewAll = lazy(() => import('../pages/Dashboard/Home/components/NotificationViewAll'));
const GeofencePage = lazy(() => import('../pages/Dashboard/Directories/Geofence/Geofence'));
const NewGeofencePage = lazy(() => import('../pages/Dashboard/Directories/Geofence/NewGeofence'));
const KnowledgeCentreLayout = lazy(
  () => import('../pages/Dashboard/Home/components/KnowledgeCentre/KnowledgeCentreLayout'),
);
const GeofenceDetailPage = lazy(() => import('../pages/Dashboard/Directories/Geofence/GeofenceDetail'));
const GroupsPage = lazy(() => import('../pages/Dashboard/Directories/Groups/Groups'));
const NewGroupsPage = lazy(() => import('../pages/Dashboard/Directories/Groups/NewGroups'));
const GroupDetailPage = lazy(() => import('../pages/Dashboard/Directories/Groups/GroupDetail'));
const AddressDetailPage = lazy(() => import('../pages/Dashboard/Directories/Address/AddressDetail'));
const EditAddressPage = lazy(() => import('../pages/Dashboard/Directories/Address/EditAddress'));
const EditGeofencePage = lazy(() => import('../pages/Dashboard/Directories/Geofence/EditGeofence'));
const DriverDetailPage = lazy(() => import('../pages/Dashboard/Directories/Drivers/DriverDetail'));
const PerformacePage = lazy(() => import('../pages/Dashboard/Directories/Drivers/Performace'));
const IgnitionTrips = lazy(() => import('../pages/Dashboard/Trips/IgnitionTrips'));
const IgnitionTripsDetails = lazy(() => import('../pages/Dashboard/Trips/IgnitionTripsDetails'));
const DriverTablePage = lazy(() => import('../pages/Dashboard/Directories/Drivers/DriverTable'));
const DriverPerformanceDetail = lazy(
  () => import('../pages/Dashboard/Directories/Drivers/DriverPerformanceDetail'),
);
const AccountSettings = lazy(() => import('../pages/Auth/AccountSettings'));
const VehicleTrackPage = lazy(() => import('../pages/Dashboard/Directories/vehicle/VehicleTrack'));
const ManageSubscription = lazy(() => import('../pages/Dashboard/Admin/ClientManageSubscription'));

export const defaultRoutes: AppRoute[] = [
  {
    path: '/vehicle/track/:id',
    element: <VehicleTrackPage />,
    layout: 'VehicleTrackLayout',
  },
  {
    path: '/',
    element: <PrivateRoute />,
    layout: 'DefaultLayout',
    children: [
      {
        path: routes.dashboard,
        element: <PrivateRoute requiredCategory={PermissionCategory.DASHBOARD} />,
        children: [{ path: '', element: <DashboardPage /> }],
      },
      {
        path: routes.vehicles,
        element: (
          <PrivateRoute
            requiredCategory={PermissionCategory.VEHICLES}
            requiredSubcategory={PermissionSubcategory.ACTIVE_VEHICLES}
          />
        ),
        children: [
          { path: '', element: <Vehicles /> },
          { path: routes.VehicleDetails, element: <VehicleDetails /> },
          { path: routes.newVehicle, element: <AddVehicleForm /> },
          { path: routes.vehicleVideos, element: <VideosPlayback /> },
          { path: routes.vehiclesDashboard, element: <VehicleDashboard /> },
        ],
      },
      {
        path: routes.serviceMaster,
        element: (
          <PrivateRoute
            requiredCategory={PermissionCategory.SERVICE_MANAGER}
            requiredSubcategory={PermissionSubcategory.SERVICE_DOWNLOADS}
          />
        ),
        children: [{ path: '', element: <ServiceMasterPage /> }],
      },
      {
        path: routes.accountSettings,
        element: <PrivateRoute requiredCategory={PermissionCategory.ADMIN} />,
        children: [{ path: '', element: <AccountSettings /> }],
      },
      {
        path: routes.notification,
        element: <PrivateRoute requiredCategory={PermissionCategory.SUPPORT} />,
        children: [{ path: '', element: <NotificationViewAll /> }],
      },
      {
        path: routes.knowledgeCentre,
        element: <PrivateRoute requiredCategory={PermissionCategory.SUPPORT} />,
        children: [{ path: '', element: <KnowledgeCentreLayout /> }],
      },
      {
        path: routes.VideoSection,
        element: <PrivateRoute requiredCategory={PermissionCategory.SUPPORT} />,
        children: [{ path: '', element: <VideoSectionViewAll /> }],
      },
      {
        path: routes.Articles,
        element: <PrivateRoute requiredCategory={PermissionCategory.SUPPORT} />,
        children: [{ path: '', element: <ArticleSectionViewAll /> }],
      },
      {
        path: routes.ViewArticles,
        element: <PrivateRoute requiredCategory={PermissionCategory.SUPPORT} />,
        children: [
          { path: '', element: <Outlet /> },
          { path: '01', element: <VehiclesSmartMobility /> },
          { path: '02', element: <DriverSafetySystem /> },
          { path: '03', element: <ComprehesiveSafetySolutions /> },
          { path: '04', element: <DMSAdvantage /> },
          { path: '05', element: <TransformingTheFuture /> },
          { path: '06', element: <HowToAvoidSleep /> },
          { path: '07', element: <DashCam /> },
          { path: '08', element: <AftermarketTelematics /> },
          { path: '09', element: <AdasIsImportant /> },
          { path: '10', element: <AutonomousVehicles /> },
          { path: '11', element: <BeyondADAS /> },
          { path: '12', element: <DriverMonitoring /> },
          { path: '13', element: <NovusSafePro /> },
          { path: '14', element: <NovusLite /> },
        ],
      },
      {
        path: routes.FaqsViewAll,
        element: <PrivateRoute requiredCategory={PermissionCategory.SUPPORT} />,
        children: [{ path: '', element: <FaqsViewAll /> }],
      },
      {
        path: routes.ignitionTrips,
        element: (
          <PrivateRoute
            requiredCategory={PermissionCategory.TRIPS}
            requiredSubcategory={PermissionSubcategory.IGNITION_BASED_TRIPS}
          />
        ),
        layout: 'TripLayout',
        children: [
          { path: '', element: <IgnitionTrips /> },
          {
            path: routes.ignitionTripsDetails,
            element: <IgnitionTripsDetails />,
          },
          { path: routes.TripsAllAlerts, element: <TripAllAlerts /> },
          { path: routes.newTrips, element: <NewTripsPage /> },
          { path: routes.newGroup, element: <NewGroupsPage /> },
          { path: routes.newRoute, element: <NewRoutePage /> },
          { path: routes.addresses, element: <Addresses /> },
          { path: routes.newDriver, element: <NewDriver /> },
          {
            path: `${routes.reconstruction}/:tripId/play`,
            element: <TRDetailPlay />,
          },
          {
            path: `${routes.reconstruction}/:tripId`,
            element: <TripReconstruction />,
          },
          {
            path: `${routes.mileStone}/:tripId/:warningSortKey`,
            element: <TRDetail />,
          },
          { path: routes.newAddress, element: <NewAddressPage /> },
          { path: `${routes.map}/:tripId`, element: <TripMap /> },
          { path: routes.newVehicle, element: <AddVehicleForm /> },
        ],
      },
      {
        path: routes.trips,
        element: (
          <PrivateRoute
            requiredCategory={PermissionCategory.TRIPS}
            requiredSubcategory={PermissionSubcategory.USER_CREATED_TRIPS}
          />
        ),
        layout: 'TripLayout',
        children: [
          { path: routes.TripsAllAlerts, element: <TripAllAlerts /> },
          { path: '', element: <TripsPage /> },
          { path: routes.newTrips, element: <NewTripsPage /> },
          { path: routes.newGroup, element: <NewGroupsPage /> },
          { path: routes.newRoute, element: <NewRoutePage /> },
          { path: routes.addresses, element: <Addresses /> },
          { path: routes.tripDetails, element: <TripDetails /> },
          { path: routes.newDriver, element: <NewDriver /> },
          {
            path: `${routes.reconstruction}/:tripId/play`,
            element: <TRDetailPlay />,
          },
          {
            path: `${routes.reconstruction}/:tripId`,
            element: <TripReconstruction />,
          },
          {
            path: `${routes.mileStone}/:tripId/:warningSortKey`,
            element: <TRDetail />,
          },
          { path: routes.newAddress, element: <NewAddressPage /> },
          { path: `${routes.map}/:tripId`, element: <TripMap /> },
          { path: routes.newVehicle, element: <AddVehicleForm /> },
        ],
      },
      {
        path: routes.document,
        element: (
          <PrivateRoute
            requiredCategory={PermissionCategory.DOCUMENTS}
            requiredSubcategory={PermissionSubcategory.ADD_DOCUMENT}
          />
        ),
        children: [{ path: '', element: <DocumentsTable /> }],
      },
      {
        path: routes.support,
        element: (
          <PrivateRoute
            requiredCategory={PermissionCategory.SUPPORT}
            requiredSubcategory={PermissionSubcategory.HELPDESK}
          />
        ),
        children: [
          { path: routes.helpDesk, element: <HelpDeskPage /> },
          { path: routes.helpDeskDetail, element: <HelpDeskDetailPage /> },
          { path: routes.troubleshoot, element: <TroubleShootPage /> },
          { path: '', element: <Navigate to={routes.helpDesk} replace /> },
        ],
      },
      {
        path: routes.directories,
        element: <PrivateRoute requiredCategory={PermissionCategory.DIRECTORIES} />,
        layout: 'DirectoryLayout',
        children: [
          {
            path: routes.groups,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.DIRECTORIES}
                requiredSubcategory={PermissionSubcategory.GROUPS}
              />
            ),
            children: [
              { path: '', element: <GroupsPage /> },
              { path: routes.newGroup, element: <NewGroupsPage /> },
              { path: routes.groupDetail, element: <GroupDetailPage /> },
              { path: routes.editGroup, element: <EditGroup /> },
            ],
          },
          {
            path: routes.devices,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.DIRECTORIES}
                requiredSubcategory={PermissionSubcategory.DEVICES}
              />
            ),
            children: [
              { path: '', element: <Devices /> },
              { path: routes.DeviceDetails, element: <DeviceDetails /> },
              { path: routes.AddDevice, element: <AddDevice /> },
              { path: routes.EditDevice, element: <AddDevice /> },
            ],
          },
          {
            path: routes.routes,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.DIRECTORIES}
                requiredSubcategory={PermissionSubcategory.ROUTES}
              />
            ),
            children: [
              { path: '', element: <Routes /> },
              { path: routes.routesDetails, element: <RouteDetails /> },
              { path: routes.newRoute, element: <NewRoutePage /> },
            ],
          },
          {
            path: routes.addresses,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.DIRECTORIES}
                requiredSubcategory={PermissionSubcategory.ADDRESSES}
              />
            ),
            children: [
              { path: '', element: <Addresses /> },
              { path: routes.addressDetail, element: <AddressDetailPage /> },
              { path: routes.newAddress, element: <NewAddressPage /> },
              { path: routes.editAddress, element: <EditAddressPage /> },
            ],
          },
          {
            path: routes.driver,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.DIRECTORIES}
                requiredSubcategory={PermissionSubcategory.MY_DRIVERS}
              />
            ),
            children: [
              { path: routes.driverDetail, element: <DriverDetailPage /> },
              { path: '', element: <DriverPage /> },
              {
                path: routes.performanceDriverTable,
                element: <DriverTablePage />,
              },
              { path: routes.performance, element: <PerformacePage /> },
              { path: routes.newDriver, element: <NewDriver /> },
            ],
          },
          // {
          //   path: routes.vehicles,
          //   element: (
          //     <PrivateRoute
          //       requiredCategory={PermissionCategory.DIRECTORIES}
          //       requiredSubcategory={PermissionSubcategory.VEHICLES}
          //     />
          //   ),
          //   children: [
          //     { path: '', element: <Vehicles /> },
          //     { path: routes.VehicleDetails, element: <VehicleDetails /> },
          //     { path: routes.newVehicle, element: <AddVehicleForm /> },
          //     { path: routes.vehicleVideos, element: <VideosPlayback /> },
          //     { path: routes.vehiclesDashboard, element: <VehicleDashboard /> },
          //   ],
          // },
          {
            path: routes.geofences,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.DIRECTORIES}
                requiredSubcategory={PermissionSubcategory.GEOFENCES}
              />
            ),
            children: [
              { path: '', element: <GeofencePage /> },
              { path: ':geofenceCode', element: <GeofenceDetailPage /> },
              { path: routes.newGeofence, element: <NewGeofencePage /> },
              { path: routes.editGeofence, element: <EditGeofencePage /> },
            ],
          },
        ],
      },
      {
        path: routes.reports,
        element: (
          <PrivateRoute
            requiredCategory={PermissionCategory.REPORTS}
            requiredSubcategory={PermissionSubcategory.ALL_REPORTS}
          />
        ),
        children: [
          { path: '', element: <ReportsPage /> },
          { path: routes.managerReport, element: <ManagerReportPage /> },
          { path: routes.alarmReport, element: <AlarmReportPage /> },
          {
            path: routes.driverPerformanceReport,
            element: <DriverPerformanceReportPage />,
          },
          {
            path: routes.deviceIgnitionReport,
            element: <DeviceIgnitionReportPage />,
          },
          {
            path: routes.deviceHealthReport,
            element: <DeviceHealthReportPage />,
          },
          { path: routes.dailyKmReport, element: <DailyKmReportPage /> },
          { path: routes.dailyRunReport, element: <DailyRunReportPage /> },
          { path: routes.dailyEventReport, element: <DailyEventReportPage /> },
          { path: routes.nightDriveReport, element: <NightDriveReportPage /> },
          {
            path: routes.continousDrivingReport,
            element: <ContinousDrivingReportPage />,
          },
          { path: routes.stoppageReport, element: <StoppageReportPage /> },
          { path: routes.geoFencingReport, element: <GeoFencingReportPage /> },
          { path: routes.passengerReport, element: <PassengersReportsPage /> },
          {
            path: routes.eLockUnlockReport,
            element: <ELockUnLockReportPage />,
          },
          {
            path: routes.tripVehicleSummary,
            element: <TripVehicleSummaryPage />,
          },
          { path: routes.createCustomReport, element: <CreateCustomReports /> },
          {
            path: routes.customReportDetails,
            element: <CustomReportCardDetal />,
          },
          {
            path: routes.customReportDetailsEdit,
            element: <EditCustomReports />,
          },
        ],
      },
      {
        path: routes.scheduledReports,
        element: (
          <PrivateRoute
            requiredCategory={PermissionCategory.REPORTS}
            requiredSubcategory={PermissionSubcategory.SCHEDULED_REPORTS}
          />
        ),
        children: [{ path: '', element: <ScheduledReportsPage /> }],
      },
      {
        path: routes.admin,
        element: <PrivateRoute requiredCategory={PermissionCategory.ADMIN} />,
        children: [
          {
            path: routes.customization,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.ADMIN}
                requiredSubcategory={PermissionSubcategory.CUSTOMIZATION}
              />
            ),
            children: [
              { path: '', element: <Customization /> },
              { path: routes.deviceLogs, element: <DeviceLogs /> },
              { path: routes.deviceUpdates, element: <DeviceUpdates /> },
              { path: routes.manageAlerts, element: <AdminManageAlerts /> },
            ],
          },
          {
            path: routes.userAccount,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.ADMIN}
                requiredSubcategory={PermissionSubcategory.USER_ACCOUNTS}
              />
            ),
            children: [{ path: '', element: <UserAccount /> }],
          },
          {
            path: routes.userSettings,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.ADMIN}
                requiredSubcategory={PermissionSubcategory.USER_SETTINGS}
              />
            ),
            children: [{ path: '', element: <UserSettings /> }],
          },
          {
            path: routes.liveStreamConfig,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.ADMIN}
                requiredSubcategory={PermissionSubcategory.LIVE_STREAM_CONFIG}
              />
            ),
            children: [{ path: '', element: <LiveStreamingConfig /> }],
          },
          {
            path: routes.userAccessControls,
            element: <PrivateRoute requiredCategory={PermissionCategory.ADMIN}
              requiredSubcategory={PermissionSubcategory.USER_ACCESS_CONTROLS} />,
            children: [{ path: '', element: <UserAccessControls /> }],
          },
          {
            path: routes.userBannerCreate,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.ADMIN}
                requiredSubcategory={PermissionSubcategory.BANNER_CONFIGURATION}
              />
            ),
            children: [{ path: '', element: <UserCreateBanner /> }],
          },
          {
            path: routes.manageSubscriptions,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.ADMIN}
                requiredSubcategory={PermissionSubcategory.MANAGE_SUBSCRIPTIONS}
              />
            ),
            children: [
              {
                path: '',
                element: <ManageSubscription />,
              },
              {
                path: routes.createNewSubscription,
                element: <NewSubscription />,
              },
              {
                path: routes.renewSubscription,
                element: <RenewSubscription />,
              },
            ]
          },
          {
            path: routes.internalSubscriptions,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.ADMIN}
                requiredSubcategory={PermissionSubcategory.INTERNAL_SUBSCRIPTIONS}
              />
            ),
            children: [
              {
                path: '',
                element: <InternalSubscriptionTable />,
              },
              {
                path: routes.createNewInternalSubscription,
                element: <NewInterNalSubscription />,
              },
              {
                path: routes.renewSubscription,
                element: <RenewSubscription />,
              },
            ]
          },
        ],
      },
      {
        path: routes.Alarm,
        element: <PrivateRoute requiredCategory={PermissionCategory.ALERTS} />,
        children: [
          {
            path: routes.VehicleAlerts,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.ALERTS}
                requiredSubcategory={PermissionSubcategory.VEHICLE_ALERTS}
              />
            ),
            children: [{ path: '', element: <Alerts /> }]
          },
          {
            path: routes.VehicleAllAlerts,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.ALERTS}
                requiredSubcategory={PermissionSubcategory.VEHICLE_ALERTS}
              />
            ),
            children: [{ path: '', element: <VehicleAllAlerts /> }]
          },
          {
            path: routes.VehicleAlertDetails,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.ALERTS}
                requiredSubcategory={PermissionSubcategory.VEHICLE_ALERTS}
              />
            ),
            children: [{ path: '', element: <VehicleAlertDetail /> }]
          },
          {
            path: routes.DriverAlerts,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.ALERTS}
                requiredSubcategory={PermissionSubcategory.DRIVER_ALERTS}
              />
            ),
            children: [{ path: '', element: <DriverAlerts /> }]
          },
          {
            path: routes.DriverAlertDashboard,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.ALERTS}
                requiredSubcategory={PermissionSubcategory.DRIVER_ALERTS}
              />
            ),
            children: [{ path: '', element: <DriverAlertDashboard /> }]
          },
          {
            path: `${routes.reconstruction}/:tripId`,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.ALERTS}
              />
            ),
            children: [{ path: '', element: <TripReconstruction /> }]
          },
          {
            path: routes.DriverCoachingDashboard,
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.ALERTS}
                requiredSubcategory={PermissionSubcategory.DRIVER_ALERTS}
              />
            ),
            children: [{ path: '', element: <DriverCoachingDashboard /> }]
          },
          {
            path: '/alarm/broadcast',
            element: (
              <PrivateRoute
                requiredCategory={PermissionCategory.ALERTS}
                requiredSubcategory={PermissionSubcategory.BROADCAST}
              />
            ),
            children: [
              { path: '', element: <Broadcast /> },
              { path: routes.newBroadcast, element: <NewBroadCast /> },
              { path: routes.broadcastDetail, element: <BrodcastDetail /> },
              { path: routes.editBroadcast, element: <EditBroadcast /> },
              { path: routes.duplicateBroadcast, element: <DuplicateBroadcast /> },
            ],
          },
        ],
      },
      {
        path: routes.DriverCoaching,
        element: (
          <PrivateRoute
            requiredCategory={PermissionCategory.DRIVER_COACHING}
            requiredSubcategory={PermissionSubcategory.UNDER_COACHING}
          />
        ),
        children: [
          { path: '', element: <DriverCoaching /> },
          {
            path: routes.DriverCoachingDashboard,
            element: <DriverCoachingDashboard />,
          },
          {
            path: routes.DriverCoachingPlaylistDetails,
            element: <CoachingDetails />,
          },
          { path: routes.driverDetail, element: <DriverDetailPage /> },
        ],
      },
      {
        path: '/driver-alerts',
        element: <PrivateRoute requiredCategory={PermissionCategory.DIRECTORIES} />,
        children: [
          { path: '', element: <DriverAlerts /> },
          {
            path: routes.DriverAlertDashboard,
            element: <DriverAlertDashboard />,
          },
        ],
      },
      {
        path: '/vehicle-alerts',
        element: <PrivateRoute requiredCategory={PermissionCategory.DIRECTORIES} />,
        children: [
          { path: '', element: <Alerts /> },
          { path: routes.VehicleAllAlerts, element: <VehicleAllAlerts /> },
          { path: routes.VehicleAlertDetails, element: <VehicleAlertDetail /> },
        ],
      },
      {
        path: routes.DriverPerformance,
        element: (
          <PrivateRoute
            requiredCategory={PermissionCategory.DRIVER_PERFORMANCE}
            requiredSubcategory={PermissionSubcategory.AVERAGE_DRIVER_SCORE}
          />
        ),
        children: [
          { path: '', element: <PerformacePage /> },
          {
            path: routes.driverPerformanceDetail,
            element: <DriverPerformanceDetail />,
          },
          { path: routes.performanceDriverTable, element: <DriverTablePage /> },
        ],
      },
      {
        path: '/helpdesk',
        element: <PrivateRoute requiredCategory={PermissionCategory.DIRECTORIES} />,
        children: [
          { path: '', element: <HelpDeskPage /> },
          { path: routes.helpDeskDetail, element: <HelpDeskDetailPage /> },
        ],
      },
      {
        path: '/all-reports',
        element: <PrivateRoute requiredCategory={PermissionCategory.REPORTS} />,
        children: [
          { path: '', element: <ReportsPage /> },
          { path: routes.managerReport, element: <ManagerReportPage /> },
          { path: routes.alarmReport, element: <AlarmReportPage /> },
          {
            path: routes.driverPerformanceReport,
            element: <DriverPerformanceReportPage />,
          },
          {
            path: routes.deviceIgnitionReport,
            element: <DeviceIgnitionReportPage />,
          },
          {
            path: routes.deviceHealthReport,
            element: <DeviceHealthReportPage />,
          },
          { path: routes.dailyKmReport, element: <DailyKmReportPage /> },
          { path: routes.dailyRunReport, element: <DailyRunReportPage /> },
          { path: routes.dailyEventReport, element: <DailyEventReportPage /> },
          { path: routes.nightDriveReport, element: <NightDriveReportPage /> },
          {
            path: routes.continousDrivingReport,
            element: <ContinousDrivingReportPage />,
          },
          { path: routes.stoppageReport, element: <StoppageReportPage /> },
          { path: routes.geoFencingReport, element: <GeoFencingReportPage /> },
          {
            path: routes.eLockUnlockReport,
            element: <ELockUnLockReportPage />,
          },
          {
            path: routes.tripVehicleSummary,
            element: <TripVehicleSummaryPage />,
          },
          { path: routes.createCustomReport, element: <CreateCustomReports /> },
          {
            path: routes.customReportDetails,
            element: <CustomReportCardDetal />,
          },
          {
            path: routes.customReportDetailsEdit,
            element: <EditCustomReports />,
          },
        ],
      },
    ],
  },
  {
    path: routes.login,
    element: <LoginPage />,
    layout: 'BlankLayout',
  },
  {
    path: routes.ApiDocumentation,
    element: <ApiDocumentation />,
    layout: 'BlankLayout',
  },
  {
    path: '/sosModal/:vehicleRegNo', // Correct path syntax
    element: <SosModal />,
    layout: 'BlankLayout',
  },
  {
    path: '/liveVideoExtModal/:vehicleRegNo',
    element: (
      <LiveVideoExtModal
        trip={undefined}
        onClose={function (): void {
          throw new Error('Function not implemented.');
        }}
        user={undefined}
      />
    ),
    layout: 'BlankLayout',
  },
];
